import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { AppView } from 'design-system';
import { rem } from 'design-system/values';
import DSStatusBar from 'design-system/StatusBar';
import Progress from 'design-system/Progress';
import useColors from 'hooks/useColors';
import { isWeb } from '../../../constants';
const UploadingView = ({ title, subtitle }) => {
    const colors = useColors();
    const content = useMemo(() => (<View style={styles.container}>
        <DSStatusBar animated barStyle="dark-content"/>
        <Progress style={styles.progress} color={colors.text.brand}/>
        <Text Text-20 centered>
          {title}
        </Text>
        <Text TextThin-16 Secondary centered>
          {subtitle}
        </Text>
      </View>), [title, subtitle, colors]);
    if (isWeb) {
        return content;
    }
    return (<AppView type="secondary" avoidHeader>
      {content}
    </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        gap: rem(16),
        paddingHorizontal: rem(16),
    },
    progress: { width: rem(70), height: rem(70), marginBottom: rem(24) },
});
export default UploadingView;
